jQuery(function ($) {

  $(".collapsible-section .heading-title").on(
    "click",
    function () {
      if ($(this).parents(".collapsible-section").hasClass("openfaq")) {
        $(this).parents(".collapsible-section").removeClass("openfaq");
      } else {
        $(".collapsible-section").removeClass("openfaq");
        $(this).parents(".collapsible-section").addClass("openfaq");
      }
    }
  );
  //menu hover
  $(".list-menu--megamenu").hover(
    function () {
      const $this = $(this);
      setTimeout(function () {
        $(".list-menu--megamenu:not(:hover)").removeClass("open");
      }, 500);
      setTimeout(function () {
        $this.addClass("open");
      }, 500);
    },
    function () { 
      setTimeout(function () {
        $(".list-menu--megamenu:not(:hover)").removeClass("open");
      }, 500);
    }
  );

  
  //external link open on new tap
  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
  
  //scroll to video
  const urlParams = new URLSearchParams(window.location.search);
  const pos = urlParams.get('pos');
  if (pos === 'video') {
    $('html, body').animate({
      scrollTop: $('video').offset().top - 100
    }, 1000);
  }

  $(document).on("item_removed", function (e) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {
        id: parseInt(e.detail.main_item_id), 
        properties: { "Gift Pack": "" } 
      },
      success: function(cart) {
        $('.cart-item[data-item-id=' + e.detail.main_item_id + ']').find('div[data-option=gift-pack]').remove();
      },
      error: function(xhr, status, error) {
        console.error('Error updating cart:', xhr.responseText);
      }
    });
  });
});
